 
export const FormHandler = () => {
    let a;
    let allow;
    let form_fields = ['voter_id', 'name', 'dob', 'age', 'rel', 'address']
    function required(name) {
        a = document.getElementById(name)
        if (!a.value) {
            a.parentNode.parentNode.style.borderColor = "red"
            a.parentNode.parentNode.parentNode.children[1].innerHTML = "Required"
            a.parentNode.parentNode.parentNode.children[1].style.visibility = "visible"
            allow = false
        }
    }
    function max_digit(name, max_digit) {
        a = document.getElementById(name)
        if (a.value  && a.value.length > max_digit) {
            a.parentNode.parentNode.style.borderColor = "red"
            a.parentNode.parentNode.parentNode.children[1].innerHTML = "Should be lessetr than " + max_digit
            a.parentNode.parentNode.parentNode.children[1].style.visibility = "visible"
            allow =false
        }
    }
    for (let i = 0; i <= form_fields.length; i++) {
        if (form_fields[i] == 'voter_id') {
            required(form_fields[i])
        }
        if (form_fields[i] == 'name') {
            required(form_fields[i])
        }
        if (form_fields[i] == 'dob') {
            required(form_fields[i])
        }
        if (form_fields[i] == 'age') {
            required(form_fields[i])
        }
        if (form_fields[i] == 'rel') {
            required(form_fields[i])
        }
        if (form_fields[i] == 'address') {
            required(form_fields[i])
        }

    }
    if(allow){
    }
}
